module.exports = {"bewizr-agenda":{"empty":{"title":"Sem atividades","detail":"Não tem atividades agendadas."}}}